import { createReducer, on } from '@ngrx/store';
import * as CatActions from './ticket-categories.actions';
import { TicketCategory } from '../../interfaces/inventory/inventory-management-interface';

export interface TicketCategoriesState {
  byStore: Record<number, TicketCategory[]>; // ← cache per store: <storeId, categories[]>
  loading: boolean;
  error: string | null;
  allCategories: TicketCategory[]; // Νέο πεδίο για όλες τις κατηγορίες
  selectedCategory: TicketCategory | null; // Επιλεγμένη κατηγορία για επεξεργασία
}

export const initialTicketCategoriesState: TicketCategoriesState = {
  byStore: {},
  loading: false,
  error: null,
  allCategories: [],
  selectedCategory: null,
};

export const ticketCategoriesReducer = createReducer(
  initialTicketCategoriesState,

  // request started → show loading spinner
  on(CatActions.loadTicketCategoriesByStore, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  // success → stash categories under byStore[storeId]
  on(CatActions.loadTicketCategoriesByStoreSuccess, (state, { storeId, categories }) => ({
    ...state,
    loading: false,
    byStore: {
      ...state.byStore,
      [storeId]: categories,
    },
  })),

  // failure → turn off loading, save error message
  on(CatActions.loadTicketCategoriesByStoreFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Φόρτωση όλων των κατηγοριών - έναρξη
  on(CatActions.loadAllTicketCategories, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  // Επιτυχής φόρτωση όλων των κατηγοριών
  on(CatActions.loadAllTicketCategoriesSuccess, (state, { categories }) => ({
    ...state,
    loading: false,
    allCategories: categories,
  })),

  // Αποτυχία φόρτωσης όλων των κατηγοριών
  on(CatActions.loadAllTicketCategoriesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Επιτυχής δημιουργία - προσθήκη στο allCategories και ενημέρωση των byStore
  on(CatActions.createTicketCategorySuccess, (state, { category }) => {
    // Δημιουργία νέας λίστας με όλες τις κατηγορίες συν τη νέα
    const updatedAllCategories = [...state.allCategories, category];

    // Δημιουργία νέου byStore με την επιπλέον κατηγορία όπου χρειάζεται
    const updatedByStore = { ...state.byStore };

    console.log('updatedAllCategories', updatedAllCategories);

    return {
      ...state,
      loading: false,
      allCategories: updatedAllCategories,
      byStore: updatedByStore,
      selectedCategory: category, // Επιλογή της κατηγορίας που μόλις δημιουργήθηκε
    };
  }),

  // Επιτυχής επεξεργασία - ενημέρωση στο allCategories και στο byStore
  on(CatActions.editTicketCategorySuccess, (state, { category }) => {
    // Ενημέρωση της λίστας με όλες τις κατηγορίες
    const updatedAllCategories = state.allCategories.map((cat) => (cat.categoryId === category.categoryId ? category : cat));

    console.log('updatedAllCategories', updatedAllCategories);

    // Ενημέρωση του byStore για κάθε store που περιέχει την κατηγορία
    const updatedByStore = { ...state.byStore };
    Object.keys(updatedByStore).forEach((storeId) => {
      const storeIdNumber = Number(storeId);
      if (updatedByStore[storeIdNumber]?.some((cat) => cat.categoryId === category.categoryId)) {
        updatedByStore[storeIdNumber] = updatedByStore[storeIdNumber].map((cat) =>
          cat.categoryId === category.categoryId ? category : cat
        );
      }
    });

    console.log('updatedAllCategories', updatedAllCategories);

    return {
      ...state,
      loading: false,
      allCategories: updatedAllCategories,
      byStore: updatedByStore,
      selectedCategory: category, // Επιλογή της κατηγορίας που μόλις ενημερώθηκε
    };
  })
);
